
document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("only-one-popup");

  if (!overlay) return;

  const closeButton = overlay.querySelector("[data-only-one-close]");
  const collectionLink = overlay.querySelector(".only-one-popup__button");
  const storageKey = "onlyOnePopupDismissed";

  function closePopup() {
    overlay.classList.add("is-hidden");
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    sessionStorage.setItem(storageKey, "true");
  }

  function openPopup() {
    overlay.classList.remove("is-hidden");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  if (closeButton) {
    closeButton.addEventListener("click", closePopup);
  }

  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) {
      closePopup();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !overlay.classList.contains("is-hidden")) {
      closePopup();
    }
  });

  if (collectionLink) {
    collectionLink.addEventListener("click", () => {
      sessionStorage.setItem(storageKey, "true");
    });
  }

  if (!sessionStorage.getItem(storageKey)) {
    window.setTimeout(openPopup, 1500);
  }
});

